import { openSecurPointApp } from "../../utils/mobileAppLinks";

const MobileAppModal = () => {

  return (
    <div
      class="modal fade  mobile-app-modal"
      id="mobileAppModal"
      tabindex="-1"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
          ></button>

          <div class="mobile-icon-wrap">
            <svg
              width="22"
              height="30"
              viewBox="0 0 22 30"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M17.333 1.33331H3.99967C2.52691 1.33331 1.33301 2.52722 1.33301 3.99998V25.3333C1.33301 26.8061 2.52691 28 3.99967 28H17.333C18.8058 28 19.9997 26.8061 19.9997 25.3333V3.99998C19.9997 2.52722 18.8058 1.33331 17.333 1.33331Z"
                stroke="#00A63E"
                stroke-width="2.66667"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>

          <div class="ct_fs_24 mx-auto" style={{ maxWidth: "300px" }}>
            This action is available on the mobile app
          </div>

          <div class="ct_fs_14 my-3">
            To keep your assets secure, this action can only be completed using
            the SecurPoint mobile app.
          </div>

          <button
            type="button"
            class="ct_green_bnt w-100"
            onClick={openSecurPointApp}
          >
            Open SecurPoint App
          </button>
        </div>
      </div>
    </div>
  );
};

export default MobileAppModal;
